const EtfExport = () =>
  import('@/views/main/etf/etfExport.vue')
export default {
  path: '/main/etf/etfExport',
  name: 'EtfExport',
  component: EtfExport,
  children: []
}